module.exports = __webpack_public_path__ + "static/img/xfyf.09ff376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/xfyf.jpg
// module id = 5xzj
// module chunks = 21